import React from "react";
import PropTypes from "prop-types";

import { BasePager } from "../BasePager";
import { Button } from "../../Button";

function DynamicPager({
    onSetPage = () => {},
    className = '',
    currentPage = 1,
    lastPage,
}) {
    return (
        <BasePager
            currentPage={currentPage}
            lastPage={lastPage}
            className={className}
            onRenderPage={(page, isActive, label) => (
                <Button
                    type="primary"
                    active={isActive}
                    onClick={() => onSetPage(page)}
                >
                    {label}
                </Button>
            )}
        />
    );
}

DynamicPager.defaultProps = {
    currentPage: 1,
    onSetPage: () => {},
    className: '',
}

DynamicPager.propTypes = {
    lastPage: PropTypes.number.isRequired,
    currentPage: PropTypes.number,
    onSetPage: PropTypes.func,
    className: PropTypes.string,
}

export { DynamicPager };
